<template>
  <figure
    itemprop="associatedMedia"
    itemscope
    class="inline-flex"
    itemtype="http://schema.org/ImageObject"
  >
    <a :href="src" itemprop="contentUrl" :data-size="resolution">
      <img class="h-full w-full object-cover lazyload" :data-src="thumbnail" itemprop="thumbnail" :alt="altText" />
    </a>
    <figcaption class="hidden" itemprop="caption description">{{ description }}</figcaption>
  </figure>
</template>

<script>
export default {
  name: 'GalleryItem',
  props: {
    src: String,
    thumbnail: String,
    altText: String,
    description: String,
    resolution: String,
  },
}
</script>
